import $ from 'jquery';

const SELECTOR = {
    SPAN_COUNTER: '.js-nav-user-counter'
}

const CLASS = {
    IS_ACTIVE: 'is-active'
}

export default class Counter {

    constructor(selectorCounter) {
        var _self = this;
        _self.$counter = $(selectorCounter);
        _self.counterVal = "0";

        var $notifSpan = _self.$counter.find(SELECTOR.SPAN_COUNTER);
        if ($notifSpan.length > 0) {
            _self.$notifSpan = $notifSpan;
        } else {
            _self.$notifSpan = $( document.createElement('span') );
            _self.$notifSpan.addClass('js-nav-user-counter rsp_counter');
            _self.$counter.append(_self.$notifSpan);
        }

        _self.notifHidden = true;
    }

    /**
     * Update the html of mobile and desktop alert notification
     * Need Id alert-dekstop and alert-mobile to work properly
     */
    updateHtml(counterVal) {
        var _self = this;

        /*
            We kept here the initial behavior even if counter is not present in the HTML
         */
        if (counterVal == "0" || counterVal == 0) {
            window.EventBusCMS.dispatchEvent('toggleBurgerMobileNotif', {state : 'unactive'});

            // check if element exist
            if (!_self.notifHidden && _self.$notifSpan !== null) {
                // hide notification span
                _self.$notifSpan.removeClass(CLASS.IS_ACTIVE);
                _self.notifHidden = true;
            }
        } else {
            window.EventBusCMS.dispatchEvent('toggleBurgerMobileNotif', {state : 'active'});

            // check if element exist
            if (_self.$notifSpan === null) {
                return;
            }

            if (_self.notifHidden) {
                // hide notification span
                _self.$notifSpan.addClass(CLASS.IS_ACTIVE);
                _self.notifHidden = false;
            }
            _self.$notifSpan.text(counterVal);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/generic/counter.js